import React from "react"
import { LinkProps as RouterLinkPropes, Link as RouterLink } from "react-router-dom"

type LinkProps = RouterLinkPropes & { disabled?: boolean };
export const Link: React.FC<LinkProps> = (props) => {
    return props.disabled
        ? <span {...props} />
        : <RouterLink {...props} />
}
export const Anchor = (props: React.AnchorHTMLAttributes<HTMLAnchorElement> & { disabled?: boolean }) => {
    return props.disabled
        ? <span {...props} />
        : <a {...props} />
}
